// registrar globalmente os components sig

export { default as SigButtonInfo } from './SigButtonInfo.vue'
export { default as SigSwitch } from './SigSwitch.vue'
export { default as SigSwitch2 } from './SigSwitch2.vue'
export { default as SigInputCurrency } from './SigInputCurrency.vue'
export { default as SigInputNumber } from './SigInputNumber.vue'
export { default as SigPrompt } from './SigPrompt.vue'
